export default "__VITE_ASSET__CnEODLA3__"